module.exports = __webpack_public_path__ + "img/Expo_Topic1.ab31b0fd.png";